import { DocumentTypeModel, IDocumentTypeModel, IPhotoModel, IStorageContentModel, PhotoModel, StorageContentModel , IModel, Model } from ".";


type AttachmentType = "Visit" | "Pet"

export interface IAttachmentModel extends IModel {
    documentTypeId: number;
    documentType: IDocumentTypeModel | undefined;
    photo: IPhotoModel | undefined;
    storageContent: IStorageContentModel | undefined
}

export class AttachmentModel extends Model implements Record<keyof IAttachmentModel, any> {
    entityId: number;
    entityType: AttachmentType;
    parentId: number;
    documentTypeId: number;
    documentType: DocumentTypeModel | undefined;
    photo: PhotoModel | undefined;
    storageContent: StorageContentModel | undefined;
    notes: string | undefined;

    constructor(params: IAttachmentModel, entityId: number, entityType: AttachmentType, parentId: number, notes?: string) {
        super(params);
        this.entityId = entityId;
        this.entityType = entityType;
        this.parentId = parentId;
        this.documentTypeId = params.documentTypeId;
        this.documentType = params.documentType ? new DocumentTypeModel(params.documentType) : undefined;
        this.photo = params.photo ? new PhotoModel(params.photo) : undefined;
        this.storageContent = params.storageContent ? new StorageContentModel(params.storageContent) : undefined;
        this.notes = notes;

    }
}

export interface IVisitAttachmentModel extends IAttachmentModel {
    visitAttachmentId: number;
    visitId: number;
}

export class VisitAttachmentModel extends AttachmentModel implements Record<keyof IVisitAttachmentModel, any> {
    visitAttachmentId: number;
    visitId: number;

    constructor(params: IVisitAttachmentModel) {
        super(params, params.visitAttachmentId, "Visit", params.visitId);
        this.visitAttachmentId = params.visitAttachmentId;
        this.visitId = params.visitId;
    }

}
